"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleBusinessProfileProviderAvailabilitySchema = exports.googleBusinessProfileConnectionStatusSchema = exports.mobileOnlineBookingLinkResponseSchema = exports.restoreOnlineBookingBuilderVersionRequestSchema = exports.publishOnlineBookingBuilderDraftRequestSchema = exports.saveOnlineBookingBuilderDraftRequestSchema = exports.onlineBookingBuilderResponseSchema = exports.onlineBookingBuilderValidationIssueSchema = exports.onlineBookingConfigurationVersionSummarySchema = exports.onlineBookingConfigurationVersionSchema = exports.onlineBookingConfigurationVersionStatusSchema = exports.onlineBookingBuilderConfigurationV1Schema = exports.onlineBookingBuilderFieldsSchema = exports.onlineBookingBuilderFieldSchema = exports.onlineBookingBuilderStepSchema = exports.onlineBookingBuilderStepIdSchema = exports.ONLINE_BOOKING_BUILDER_SCHEMA_VERSION = exports.onlineBookingSettingsResponseSchema = exports.onlineBookingSettingsSchema = exports.onlineBookingEmbedSettingsSchema = exports.onlineBookingEmbedDiagnosticsSchema = exports.onlineBookingEmbedConfigurationSchema = exports.onlineBookingEmbedRedirectUrlSchema = exports.onlineBookingEmbedOriginSchema = exports.ONLINE_BOOKING_EMBED_PROTOCOL_VERSION = exports.onlineBookingServiceAreaPermissionsSchema = exports.onlineBookingServiceAreaSummarySchema = exports.updateOnlineBookingServiceAreaSettingsRequestSchema = exports.onlineBookingServiceAreaSettingsSchema = exports.onlineBookingServiceAreaZipEntrySchema = exports.onlineBookingServiceAreaZipEntryInputSchema = exports.onlineBookingTechnicianSchema = exports.onlineBookingOperationalLocationSchema = exports.onlineBookingServiceCapabilitySchema = exports.onlineBookingBlackoutPeriodSchema = exports.onlineBookingBlackoutInputSchema = exports.onlineBookingWeeklyHoursSchema = exports.onlineBookingHourWindowSchema = exports.onlineBookingAvailabilityReasonCodeSchema = exports.onlineBookingPaymentModeSchema = exports.onlineBookingServiceCombinationErrorSchema = exports.onlineBookingServiceCombinationReasonCodeSchema = exports.publicOnlineBookingLineItemSnapshotSchema = exports.publicOnlineBookingLineItemsSchema = exports.publicOnlineBookingLineItemInputSchema = exports.PUBLIC_ONLINE_BOOKING_MAX_COMBINED_DURATION_MINUTES = exports.PUBLIC_ONLINE_BOOKING_MAX_LINE_QUANTITY = exports.PUBLIC_ONLINE_BOOKING_MAX_LINE_ITEMS = exports.onlineBookingServiceSchema = exports.usZip5Schema = void 0;
exports.publicOnlineBookingSubmissionResponseSchema = exports.publicOnlineBookingSubmissionRequestSchema = exports.publicOnlineBookingAddressSchema = exports.mobileAvailabilityProfileResponseSchema = exports.publicOnlineBookingServiceAreaEligibilityResponseSchema = exports.publicOnlineBookingServiceAreaEligibilityQuerySchema = exports.onlineBookingOutOfAreaErrorSchema = exports.ONLINE_BOOKING_OUT_OF_AREA_ERROR_CODE = exports.onlineBookingSlotUnavailableDetailSchema = exports.onlineBookingAvailabilityDiagnosticsResponseSchema = exports.onlineBookingAvailabilityDiagnosticsQuerySchema = exports.onlineBookingAvailabilityDiagnosticSlotSchema = exports.publicOnlineBookingAvailabilityResponseSchema = exports.publicOnlineBookingSlotSchema = exports.publicOnlineBookingCartAvailabilityRequestSchema = exports.publicOnlineBookingAvailabilityQuerySchema = exports.publicOnlineBookingEmbedTelemetryResponseSchema = exports.publicOnlineBookingEmbedTelemetryRequestSchema = exports.publicOnlineBookingEmbedTelemetryEventTypeSchema = exports.publicOnlineBookingEmbedMessageSchema = exports.publicOnlineBookingEmbedSessionResponseSchema = exports.publicOnlineBookingEmbedSessionQuerySchema = exports.publicOnlineBookingEmbedThemeSchema = exports.publicOnlineBookingBusinessQuerySchema = exports.publicOnlineBookingBusinessSchema = exports.updateOnlineBookingSettingsRequestSchema = exports.updateGoogleBusinessProfilePublicationRequestSchema = exports.selectGoogleBusinessProfileRequestSchema = exports.completeGoogleBusinessProfileConnectionRequestSchema = exports.googleBusinessProfileAuthorizationResponseSchema = exports.googleBusinessProfileConnectionSchema = exports.googleBusinessProfileLocationSchema = exports.googleBusinessProfilePublicationStatusSchema = void 0;
exports.normalizeUsZip5 = normalizeUsZip5;
exports.normalizePublicOnlineBookingLineItems = normalizePublicOnlineBookingLineItems;
const zod_1 = require("zod");
const lead_1 = require("./lead");
const team_1 = require("./team");
const bookingMoneySchema = zod_1.z.number().int().min(0).max(100_000_000);
const bookingDateSchema = zod_1.z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Use a YYYY-MM-DD date.");
exports.usZip5Schema = zod_1.z
    .string()
    .trim()
    .regex(/^\d{5}(?:-\d{4})?$/, "Use a valid US ZIP or ZIP+4 code.")
    .transform((value) => value.slice(0, 5));
function normalizeUsZip5(value) {
    return exports.usZip5Schema.parse(value);
}
exports.onlineBookingServiceSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    durationMinutes: zod_1.z.number().int().min(5).max(1_440),
    priceCents: bookingMoneySchema,
});
exports.PUBLIC_ONLINE_BOOKING_MAX_LINE_ITEMS = 10;
exports.PUBLIC_ONLINE_BOOKING_MAX_LINE_QUANTITY = 25;
exports.PUBLIC_ONLINE_BOOKING_MAX_COMBINED_DURATION_MINUTES = 1_440;
exports.publicOnlineBookingLineItemInputSchema = zod_1.z.object({
    serviceId: zod_1.z.string().uuid(),
    quantity: zod_1.z
        .number()
        .int()
        .min(1)
        .max(exports.PUBLIC_ONLINE_BOOKING_MAX_LINE_QUANTITY)
        .default(1),
    notes: zod_1.z.string().trim().max(2_000).optional(),
});
exports.publicOnlineBookingLineItemsSchema = zod_1.z
    .array(exports.publicOnlineBookingLineItemInputSchema)
    .min(1)
    .max(exports.PUBLIC_ONLINE_BOOKING_MAX_LINE_ITEMS)
    .superRefine((items, context) => {
    const serviceIds = new Set();
    items.forEach((item, index) => {
        if (serviceIds.has(item.serviceId)) {
            context.addIssue({
                code: "custom",
                path: [index, "serviceId"],
                message: "Use quantity instead of adding a service twice.",
            });
        }
        serviceIds.add(item.serviceId);
    });
});
exports.publicOnlineBookingLineItemSnapshotSchema = zod_1.z.object({
    serviceId: zod_1.z.string().uuid(),
    position: zod_1.z.number().int().nonnegative(),
    name: zod_1.z.string().min(1),
    quantity: zod_1.z.number().int().positive(),
    unitPriceCents: bookingMoneySchema,
    lineTotalCents: zod_1.z.number().int().nonnegative(),
    unitDurationMinutes: zod_1.z.number().int().min(5).max(1_440),
    totalDurationMinutes: zod_1.z
        .number()
        .int()
        .min(5)
        .max(exports.PUBLIC_ONLINE_BOOKING_MAX_COMBINED_DURATION_MINUTES),
    notes: zod_1.z.string().max(2_000).nullable(),
    priceBookVersionId: zod_1.z.string().uuid().nullable().optional(),
});
exports.onlineBookingServiceCombinationReasonCodeSchema = zod_1.z.enum([
    "NO_SHARED_TECHNICIAN",
    "COMBINED_DURATION_EXCEEDED",
    "COMBINED_PRICE_EXCEEDED",
]);
exports.onlineBookingServiceCombinationErrorSchema = zod_1.z.object({
    code: zod_1.z.literal("ONLINE_BOOKING_SERVICE_COMBINATION_INVALID"),
    message: zod_1.z.string(),
    reasonCode: exports.onlineBookingServiceCombinationReasonCodeSchema,
    serviceIds: zod_1.z.array(zod_1.z.string().uuid()).min(1).max(10),
});
exports.onlineBookingPaymentModeSchema = zod_1.z.enum([
    "NONE",
    "FULL_PREPAYMENT",
]);
exports.onlineBookingAvailabilityReasonCodeSchema = zod_1.z.enum([
    "DATE_IN_PAST",
    "OUTSIDE_BOOKING_HORIZON",
    "MINIMUM_LEAD_TIME",
    "OUTSIDE_BUSINESS_HOURS",
    "OUTSIDE_ONLINE_BOOKING_HOURS",
    "BLACKOUT_PERIOD",
    "DST_INVALID_LOCAL_TIME",
    "SERVICE_LOCATION_UNSUPPORTED",
    "NO_ELIGIBLE_TECHNICIAN",
    "TECHNICIAN_OFF_HOURS",
    "TECHNICIAN_BUSY",
    "CAPACITY_EXHAUSTED",
    "BUFFER_CONFLICT",
    "TRAVEL_TIME_CONFLICT",
]);
exports.onlineBookingHourWindowSchema = zod_1.z
    .object({
    weekday: team_1.teamWeekdaySchema,
    startMinute: zod_1.z.number().int().min(0).max(1_439),
    endMinute: zod_1.z.number().int().min(1).max(1_440),
})
    .refine((value) => value.startMinute < value.endMinute, {
    path: ["endMinute"],
    message: "Hour window end must follow its start.",
});
exports.onlineBookingWeeklyHoursSchema = zod_1.z
    .array(exports.onlineBookingHourWindowSchema)
    .max(56)
    .superRefine((windows, context) => {
    for (const weekday of team_1.teamWeekdaySchema.options) {
        const daily = windows
            .filter((window) => window.weekday === weekday)
            .sort((left, right) => left.startMinute - right.startMinute);
        for (let index = 1; index < daily.length; index += 1) {
            if (daily[index].startMinute < daily[index - 1].endMinute) {
                context.addIssue({
                    code: "custom",
                    path: [windows.indexOf(daily[index])],
                    message: "Hour windows cannot overlap.",
                });
            }
        }
    }
});
exports.onlineBookingBlackoutInputSchema = zod_1.z
    .object({
    startAt: zod_1.z.string().datetime(),
    endAt: zod_1.z.string().datetime(),
    label: zod_1.z.string().trim().min(1).max(120),
})
    .refine((value) => Date.parse(value.endAt) > Date.parse(value.startAt), {
    path: ["endAt"],
    message: "Blackout end must follow its start.",
});
exports.onlineBookingBlackoutPeriodSchema = exports.onlineBookingBlackoutInputSchema.extend({ id: zod_1.z.string().uuid() });
exports.onlineBookingServiceCapabilitySchema = zod_1.z.object({
    serviceId: zod_1.z.string().uuid(),
    technicianMembershipIds: zod_1.z.array(zod_1.z.string().uuid()).max(250),
});
exports.onlineBookingOperationalLocationSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string().min(1),
    timezone: zod_1.z.string().min(1),
    isDefault: zod_1.z.boolean(),
});
exports.onlineBookingTechnicianSchema = zod_1.z.object({
    membershipId: zod_1.z.string().uuid(),
    displayName: zod_1.z.string().min(1),
});
exports.onlineBookingServiceAreaZipEntryInputSchema = zod_1.z.object({
    postalCode: exports.usZip5Schema,
    active: zod_1.z.boolean().default(true),
});
exports.onlineBookingServiceAreaZipEntrySchema = exports.onlineBookingServiceAreaZipEntryInputSchema.extend({
    id: zod_1.z.string().uuid(),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
});
const onlineBookingOutOfAreaMessageSchema = zod_1.z.string().trim().min(1).max(500);
exports.onlineBookingServiceAreaSettingsSchema = zod_1.z.object({
    operationalLocationId: zod_1.z.string().uuid(),
    enforcementEnabled: zod_1.z.boolean(),
    outOfAreaMessage: onlineBookingOutOfAreaMessageSchema,
    zipEntries: zod_1.z.array(exports.onlineBookingServiceAreaZipEntrySchema).max(5_000),
    updatedAt: zod_1.z.string().datetime(),
});
exports.updateOnlineBookingServiceAreaSettingsRequestSchema = zod_1.z
    .object({
    operationalLocationId: zod_1.z.string().uuid(),
    enforcementEnabled: zod_1.z.boolean(),
    outOfAreaMessage: onlineBookingOutOfAreaMessageSchema,
    zipEntries: zod_1.z.array(exports.onlineBookingServiceAreaZipEntryInputSchema).max(5_000),
})
    .superRefine((value, context) => {
    const postalCodes = value.zipEntries.map((entry) => entry.postalCode);
    if (new Set(postalCodes).size !== postalCodes.length) {
        context.addIssue({
            code: "custom",
            path: ["zipEntries"],
            message: "Service-area ZIP codes must be unique.",
        });
    }
    if (value.enforcementEnabled &&
        !value.zipEntries.some((entry) => entry.active)) {
        context.addIssue({
            code: "custom",
            path: ["zipEntries"],
            message: "At least one active ZIP code is required when service-area enforcement is enabled.",
        });
    }
});
exports.onlineBookingServiceAreaSummarySchema = zod_1.z.object({
    operationalLocationId: zod_1.z.string().uuid(),
    enforcementEnabled: zod_1.z.boolean(),
    activeZipCount: zod_1.z.number().int().nonnegative(),
});
exports.onlineBookingServiceAreaPermissionsSchema = zod_1.z.object({
    canRead: zod_1.z.boolean(),
    canManage: zod_1.z.boolean(),
});
exports.ONLINE_BOOKING_EMBED_PROTOCOL_VERSION = "1.0";
exports.onlineBookingEmbedOriginSchema = zod_1.z
    .string()
    .trim()
    .min(1)
    .max(2_048)
    .refine(isSafeEmbedOrigin, "Use an exact HTTPS origin without a path.");
exports.onlineBookingEmbedRedirectUrlSchema = zod_1.z
    .string()
    .trim()
    .min(1)
    .max(2_048)
    .refine(isSafeEmbedRedirectUrl, "Use a safe HTTPS redirect URL.");
exports.onlineBookingEmbedConfigurationSchema = zod_1.z
    .object({
    allowedOrigins: zod_1.z
        .array(exports.onlineBookingEmbedOriginSchema)
        .max(25)
        .refine((origins) => new Set(origins).size === origins.length, "Embed origins must be unique."),
    completionRedirectUrl: exports.onlineBookingEmbedRedirectUrlSchema.nullable(),
    cancellationRedirectUrl: exports.onlineBookingEmbedRedirectUrlSchema.nullable(),
})
    .superRefine((value, context) => {
    for (const [field, redirectUrl] of [
        ["completionRedirectUrl", value.completionRedirectUrl],
        ["cancellationRedirectUrl", value.cancellationRedirectUrl],
    ]) {
        if (redirectUrl &&
            !value.allowedOrigins.includes(new URL(redirectUrl).origin)) {
            context.addIssue({
                code: "custom",
                path: [field],
                message: "Redirect origins must also be allowed embed origins.",
            });
        }
    }
});
exports.onlineBookingEmbedDiagnosticsSchema = zod_1.z.object({
    windowHours: zod_1.z.literal(24),
    readyCount: zod_1.z.number().int().nonnegative(),
    completionCount: zod_1.z.number().int().nonnegative(),
    cancellationCount: zod_1.z.number().int().nonnegative(),
    failureCount: zod_1.z.number().int().nonnegative(),
    slowLoadCount: zod_1.z.number().int().nonnegative(),
    p95ReadyMs: zod_1.z.number().int().nonnegative().nullable(),
    lastEventAt: zod_1.z.string().datetime().nullable(),
});
exports.onlineBookingEmbedSettingsSchema = exports.onlineBookingEmbedConfigurationSchema.extend({
    protocolVersion: zod_1.z.literal(exports.ONLINE_BOOKING_EMBED_PROTOCOL_VERSION),
    widgetScriptUrl: zod_1.z.string().url(),
    embedUrl: zod_1.z.string().url(),
    diagnostics: exports.onlineBookingEmbedDiagnosticsSchema,
});
exports.onlineBookingSettingsSchema = zod_1.z.object({
    enabled: zod_1.z.boolean(),
    minimumNoticeHours: zod_1.z.number().int().min(0).max(720),
    bookingHorizonDays: zod_1.z.number().int().min(1).max(180),
    slotIntervalMinutes: zod_1.z.number().int().min(5).max(240),
    operationalLocationId: zod_1.z.string().uuid(),
    capacity: zod_1.z.number().int().min(1).max(100),
    bufferBeforeMinutes: zod_1.z.number().int().min(0).max(240),
    bufferAfterMinutes: zod_1.z.number().int().min(0).max(240),
    travelTimeMinutes: zod_1.z.number().int().min(0).max(240),
    businessHours: exports.onlineBookingWeeklyHoursSchema,
    onlineBookingHours: exports.onlineBookingWeeklyHoursSchema,
    blackoutPeriods: zod_1.z.array(exports.onlineBookingBlackoutPeriodSchema).max(250),
    serviceCapabilities: zod_1.z.array(exports.onlineBookingServiceCapabilitySchema).max(100),
    serviceArea: exports.onlineBookingServiceAreaSettingsSchema.optional(),
    embed: exports.onlineBookingEmbedSettingsSchema.optional(),
    paymentMode: exports.onlineBookingPaymentModeSchema,
    serviceIds: zod_1.z.array(zod_1.z.string().uuid()).max(100),
    bookingUrl: zod_1.z.string().url(),
    googleBusinessProfile: zod_1.z.object({
        bookingUrl: zod_1.z.string().url(),
        managementUrl: zod_1.z.string().url(),
    }),
    updatedAt: zod_1.z.string().datetime(),
});
exports.onlineBookingSettingsResponseSchema = zod_1.z.object({
    settings: exports.onlineBookingSettingsSchema,
    availableServices: zod_1.z.array(exports.onlineBookingServiceSchema),
    operationalLocations: zod_1.z.array(exports.onlineBookingOperationalLocationSchema),
    technicians: zod_1.z.array(exports.onlineBookingTechnicianSchema),
    serviceAreaPermissions: exports.onlineBookingServiceAreaPermissionsSchema.default({
        canRead: false,
        canManage: false,
    }),
    canManage: zod_1.z.boolean(),
});
exports.ONLINE_BOOKING_BUILDER_SCHEMA_VERSION = 1;
exports.onlineBookingBuilderStepIdSchema = zod_1.z.enum([
    "SERVICE",
    "SCHEDULE",
    "DETAILS",
    "REVIEW",
]);
exports.onlineBookingBuilderStepSchema = zod_1.z.object({
    id: exports.onlineBookingBuilderStepIdSchema,
    enabled: zod_1.z.boolean(),
    title: zod_1.z.string().trim().min(1).max(80),
    description: zod_1.z.string().trim().min(1).max(240),
});
exports.onlineBookingBuilderFieldSchema = zod_1.z
    .object({
    visible: zod_1.z.boolean(),
    required: zod_1.z.boolean(),
})
    .refine((value) => value.visible || !value.required, {
    path: ["required"],
    message: "A hidden field cannot be required.",
});
exports.onlineBookingBuilderFieldsSchema = zod_1.z.object({
    firstName: exports.onlineBookingBuilderFieldSchema,
    lastName: exports.onlineBookingBuilderFieldSchema,
    email: exports.onlineBookingBuilderFieldSchema,
    phone: exports.onlineBookingBuilderFieldSchema,
    companyName: exports.onlineBookingBuilderFieldSchema,
    addressLine1: exports.onlineBookingBuilderFieldSchema,
    addressLine2: exports.onlineBookingBuilderFieldSchema,
    city: exports.onlineBookingBuilderFieldSchema,
    state: exports.onlineBookingBuilderFieldSchema,
    postalCode: exports.onlineBookingBuilderFieldSchema,
    notes: exports.onlineBookingBuilderFieldSchema,
});
const onlineBookingBuilderCoreFieldIds = [
    "firstName",
    "lastName",
    "addressLine1",
    "city",
    "state",
    "postalCode",
];
exports.onlineBookingBuilderConfigurationV1Schema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.ONLINE_BOOKING_BUILDER_SCHEMA_VERSION),
    branding: zod_1.z.object({
        primaryAccentColor: zod_1.z.string().regex(/^#[0-9a-f]{6}$/i),
        showBusinessLogo: zod_1.z.boolean(),
    }),
    content: zod_1.z.object({
        headline: zod_1.z.string().trim().min(2).max(160),
        introduction: zod_1.z.string().trim().min(2).max(500),
        confirmationTitle: zod_1.z.string().trim().min(2).max(120),
        confirmationMessage: zod_1.z.string().trim().min(2).max(500),
    }),
    steps: zod_1.z.array(exports.onlineBookingBuilderStepSchema).length(4),
    fields: exports.onlineBookingBuilderFieldsSchema,
    serviceIds: zod_1.z.array(zod_1.z.string().uuid()).max(100),
})
    .superRefine((value, context) => {
    const expectedSteps = exports.onlineBookingBuilderStepIdSchema.options;
    if (value.steps.some((step, index) => step.id !== expectedSteps[index])) {
        context.addIssue({
            code: "custom",
            path: ["steps"],
            message: "Booking steps must use the supported V1 order.",
        });
    }
    for (const stepId of ["SERVICE", "SCHEDULE", "DETAILS"]) {
        const stepIndex = value.steps.findIndex((step) => step.id === stepId);
        if (stepIndex < 0 || !value.steps[stepIndex]?.enabled) {
            context.addIssue({
                code: "custom",
                path: ["steps", Math.max(stepIndex, 0), "enabled"],
                message: `${stepId} is a required booking step.`,
            });
        }
    }
    for (const fieldId of onlineBookingBuilderCoreFieldIds) {
        const field = value.fields[fieldId];
        if (!field.visible || !field.required) {
            context.addIssue({
                code: "custom",
                path: ["fields", fieldId],
                message: "Core customer and service-address fields must stay visible and required.",
            });
        }
    }
    if (!value.fields.email.visible && !value.fields.phone.visible) {
        context.addIssue({
            code: "custom",
            path: ["fields", "email"],
            message: "At least one contact field must stay visible.",
        });
    }
    if (new Set(value.serviceIds).size !== value.serviceIds.length) {
        context.addIssue({
            code: "custom",
            path: ["serviceIds"],
            message: "Bookable services must be unique.",
        });
    }
});
exports.onlineBookingConfigurationVersionStatusSchema = zod_1.z.enum([
    "DRAFT",
    "PUBLISHED",
    "ARCHIVED",
]);
exports.onlineBookingConfigurationVersionSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    versionNumber: zod_1.z.number().int().positive(),
    status: exports.onlineBookingConfigurationVersionStatusSchema,
    revision: zod_1.z.number().int().positive(),
    basedOnVersionId: zod_1.z.string().uuid().nullable(),
    configuration: exports.onlineBookingBuilderConfigurationV1Schema,
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
    publishedAt: zod_1.z.string().datetime().nullable(),
});
exports.onlineBookingConfigurationVersionSummarySchema = exports.onlineBookingConfigurationVersionSchema.omit({ configuration: true });
exports.onlineBookingBuilderValidationIssueSchema = zod_1.z.object({
    code: zod_1.z.enum([
        "SERVICE_REQUIRED",
        "SERVICE_UNAVAILABLE",
        "LOCATION_UNAVAILABLE",
        "SERVICE_AREA_INVALID",
    ]),
    path: zod_1.z.string().min(1).max(160),
    message: zod_1.z.string().min(1).max(500),
});
exports.onlineBookingBuilderResponseSchema = zod_1.z.object({
    draft: exports.onlineBookingConfigurationVersionSchema,
    published: exports.onlineBookingConfigurationVersionSchema.nullable(),
    history: zod_1.z.array(exports.onlineBookingConfigurationVersionSummarySchema).max(100),
    availableServices: zod_1.z.array(exports.onlineBookingServiceSchema),
    bookingUrl: zod_1.z.string().url(),
    validation: zod_1.z.object({
        valid: zod_1.z.boolean(),
        issues: zod_1.z.array(exports.onlineBookingBuilderValidationIssueSchema).max(100),
    }),
    canManage: zod_1.z.boolean(),
});
exports.saveOnlineBookingBuilderDraftRequestSchema = zod_1.z.object({
    expectedRevision: zod_1.z.number().int().positive(),
    configuration: exports.onlineBookingBuilderConfigurationV1Schema,
});
exports.publishOnlineBookingBuilderDraftRequestSchema = zod_1.z.object({
    expectedRevision: zod_1.z.number().int().positive(),
});
exports.restoreOnlineBookingBuilderVersionRequestSchema = zod_1.z.object({
    sourceVersionId: zod_1.z.string().uuid(),
    expectedDraftRevision: zod_1.z.number().int().positive(),
});
exports.mobileOnlineBookingLinkResponseSchema = zod_1.z.object({
    enabled: zod_1.z.boolean(),
    bookingUrl: zod_1.z.string().url(),
    displayName: zod_1.z.string().min(1),
    operationalLocation: exports.onlineBookingOperationalLocationSchema.pick({
        id: true,
        name: true,
        timezone: true,
    }),
    configurationVersionId: zod_1.z.string().uuid().nullable(),
});
exports.googleBusinessProfileConnectionStatusSchema = zod_1.z.enum([
    "NOT_CONNECTED",
    "CONNECTING",
    "CONNECTED",
    "NEEDS_ATTENTION",
]);
exports.googleBusinessProfileProviderAvailabilitySchema = zod_1.z.enum([
    "READY",
    "NOT_CONFIGURED",
    "API_ACCESS_REQUIRED",
]);
exports.googleBusinessProfilePublicationStatusSchema = zod_1.z.enum([
    "NOT_PUBLISHED",
    "ACTION_REQUIRED",
    "USER_CONFIRMED",
    "PUBLISHED",
]);
exports.googleBusinessProfileLocationSchema = zod_1.z.object({
    resourceName: zod_1.z.string().min(1).max(240),
    accountResourceName: zod_1.z.string().min(1).max(240),
    displayName: zod_1.z.string().min(1).max(240),
    formattedAddress: zod_1.z.string().max(500).nullable(),
});
exports.googleBusinessProfileConnectionSchema = zod_1.z.object({
    status: exports.googleBusinessProfileConnectionStatusSchema,
    providerAvailability: exports.googleBusinessProfileProviderAvailabilitySchema,
    profile: exports.googleBusinessProfileLocationSchema.nullable(),
    availableProfiles: zod_1.z.array(exports.googleBusinessProfileLocationSchema).max(250),
    publicationMode: zod_1.z.literal("MANUAL_LINK"),
    publicationStatus: exports.googleBusinessProfilePublicationStatusSchema,
    lastCheckedAt: zod_1.z.string().datetime().nullable(),
    error: zod_1.z.string().max(500).nullable(),
    canManage: zod_1.z.boolean(),
});
exports.googleBusinessProfileAuthorizationResponseSchema = zod_1.z.object({
    authorizationUrl: zod_1.z.string().url(),
});
exports.completeGoogleBusinessProfileConnectionRequestSchema = zod_1.z.object({
    code: zod_1.z.string().trim().min(1).max(4_096),
    state: zod_1.z.string().trim().min(24).max(512),
});
exports.selectGoogleBusinessProfileRequestSchema = zod_1.z.object({
    resourceName: zod_1.z.string().trim().min(1).max(240),
});
exports.updateGoogleBusinessProfilePublicationRequestSchema = zod_1.z.object({
    published: zod_1.z.boolean(),
});
exports.updateOnlineBookingSettingsRequestSchema = zod_1.z
    .object({
    enabled: zod_1.z.boolean(),
    minimumNoticeHours: zod_1.z.number().int().min(0).max(720),
    bookingHorizonDays: zod_1.z.number().int().min(1).max(180),
    slotIntervalMinutes: zod_1.z.number().int().min(5).max(240),
    operationalLocationId: zod_1.z.string().uuid().optional(),
    capacity: zod_1.z.number().int().min(1).max(100).optional(),
    bufferBeforeMinutes: zod_1.z.number().int().min(0).max(240).optional(),
    bufferAfterMinutes: zod_1.z.number().int().min(0).max(240).optional(),
    travelTimeMinutes: zod_1.z.number().int().min(0).max(240).optional(),
    businessHours: exports.onlineBookingWeeklyHoursSchema.optional(),
    onlineBookingHours: exports.onlineBookingWeeklyHoursSchema.optional(),
    blackoutPeriods: zod_1.z
        .array(exports.onlineBookingBlackoutInputSchema)
        .max(250)
        .optional(),
    serviceCapabilities: zod_1.z
        .array(exports.onlineBookingServiceCapabilitySchema)
        .max(100)
        .optional(),
    serviceArea: exports.updateOnlineBookingServiceAreaSettingsRequestSchema.optional(),
    embed: exports.onlineBookingEmbedConfigurationSchema.optional(),
    paymentMode: exports.onlineBookingPaymentModeSchema,
    serviceIds: zod_1.z.array(zod_1.z.string().uuid()).max(100),
})
    .refine((value) => new Set(value.serviceIds).size === value.serviceIds.length, {
    path: ["serviceIds"],
    message: "Services must be unique.",
})
    .superRefine((value, context) => {
    if (value.serviceArea &&
        value.operationalLocationId &&
        value.serviceArea.operationalLocationId !== value.operationalLocationId) {
        context.addIssue({
            code: "custom",
            path: ["serviceArea", "operationalLocationId"],
            message: "Service-area settings must match the selected operational location.",
        });
    }
    if (value.serviceCapabilities) {
        const serviceIds = new Set();
        value.serviceCapabilities.forEach((item, index) => {
            if (serviceIds.has(item.serviceId)) {
                context.addIssue({
                    code: "custom",
                    path: ["serviceCapabilities", index, "serviceId"],
                    message: "Service capability mappings must be unique.",
                });
            }
            serviceIds.add(item.serviceId);
            if (new Set(item.technicianMembershipIds).size !==
                item.technicianMembershipIds.length) {
                context.addIssue({
                    code: "custom",
                    path: ["serviceCapabilities", index, "technicianMembershipIds"],
                    message: "Technicians must be unique for each service.",
                });
            }
        });
    }
    if (value.blackoutPeriods) {
        const sorted = [...value.blackoutPeriods].sort((left, right) => Date.parse(left.startAt) - Date.parse(right.startAt));
        for (let index = 1; index < sorted.length; index += 1) {
            if (Date.parse(sorted[index].startAt) <
                Date.parse(sorted[index - 1].endAt)) {
                context.addIssue({
                    code: "custom",
                    path: ["blackoutPeriods"],
                    message: "Blackout periods cannot overlap.",
                });
                break;
            }
        }
    }
});
exports.publicOnlineBookingBusinessSchema = zod_1.z.object({
    configurationVersionId: zod_1.z.string().uuid(),
    configuration: exports.onlineBookingBuilderConfigurationV1Schema,
    canonicalSlug: lead_1.publicLeadIntakeSlugSchema,
    displayName: zod_1.z.string(),
    logoUrl: zod_1.z.string().url().nullable(),
    primaryAccentColor: zod_1.z.string().regex(/^#[0-9a-f]{6}$/i),
    timezone: zod_1.z.string(),
    operationalLocation: exports.onlineBookingOperationalLocationSchema.pick({
        id: true,
        name: true,
        timezone: true,
    }),
    headline: zod_1.z.string(),
    introduction: zod_1.z.string(),
    requireConsent: zod_1.z.boolean(),
    consentText: zod_1.z.string(),
    privacyPolicyUrl: zod_1.z.string().url().nullable(),
    services: zod_1.z.array(exports.onlineBookingServiceSchema),
});
exports.publicOnlineBookingBusinessQuerySchema = zod_1.z.object({
    configurationVersionId: zod_1.z.string().uuid().optional(),
});
exports.publicOnlineBookingEmbedThemeSchema = zod_1.z.enum([
    "LIGHT",
    "DARK",
    "SYSTEM",
]);
exports.publicOnlineBookingEmbedSessionQuerySchema = zod_1.z.object({
    parentOrigin: exports.onlineBookingEmbedOriginSchema,
    channelId: zod_1.z.string().uuid(),
    theme: exports.publicOnlineBookingEmbedThemeSchema.default("SYSTEM"),
});
exports.publicOnlineBookingEmbedSessionResponseSchema = zod_1.z.object({
    protocolVersion: zod_1.z.literal(exports.ONLINE_BOOKING_EMBED_PROTOCOL_VERSION),
    channelId: zod_1.z.string().uuid(),
    parentOrigin: exports.onlineBookingEmbedOriginSchema,
    theme: exports.publicOnlineBookingEmbedThemeSchema,
    hostedBookingUrl: zod_1.z.string().url(),
    completionRedirectUrl: exports.onlineBookingEmbedRedirectUrlSchema.nullable(),
    cancellationRedirectUrl: exports.onlineBookingEmbedRedirectUrlSchema.nullable(),
});
const publicOnlineBookingEmbedMessageEnvelopeSchema = zod_1.z.object({
    protocolVersion: zod_1.z.literal(exports.ONLINE_BOOKING_EMBED_PROTOCOL_VERSION),
    channelId: zod_1.z.string().uuid(),
    eventId: zod_1.z.string().uuid(),
    occurredAt: zod_1.z.string().datetime({ offset: true }),
});
exports.publicOnlineBookingEmbedMessageSchema = zod_1.z.discriminatedUnion("type", [
    publicOnlineBookingEmbedMessageEnvelopeSchema.extend({
        type: zod_1.z.literal("READY"),
        payload: zod_1.z.object({ height: zod_1.z.number().int().min(320).max(2_400) }),
    }),
    publicOnlineBookingEmbedMessageEnvelopeSchema.extend({
        type: zod_1.z.literal("RESIZE"),
        payload: zod_1.z.object({ height: zod_1.z.number().int().min(320).max(2_400) }),
    }),
    publicOnlineBookingEmbedMessageEnvelopeSchema.extend({
        type: zod_1.z.literal("COMPLETED"),
        payload: zod_1.z.object({
            confirmationCode: zod_1.z.string().regex(/^CF-[A-Z0-9]{10}$/),
            redirectRequested: zod_1.z.boolean(),
            redirectUrl: exports.onlineBookingEmbedRedirectUrlSchema.nullable(),
        }),
    }),
    publicOnlineBookingEmbedMessageEnvelopeSchema.extend({
        type: zod_1.z.literal("CANCELLED"),
        payload: zod_1.z.object({
            redirectRequested: zod_1.z.boolean(),
            redirectUrl: exports.onlineBookingEmbedRedirectUrlSchema.nullable(),
        }),
    }),
    publicOnlineBookingEmbedMessageEnvelopeSchema.extend({
        type: zod_1.z.literal("FAILED"),
        payload: zod_1.z.object({ code: zod_1.z.string().trim().min(1).max(80) }),
    }),
]);
exports.publicOnlineBookingEmbedTelemetryEventTypeSchema = zod_1.z.enum([
    "READY",
    "COMPLETED",
    "CANCELLED",
    "FAILED",
    "SLOW_LOAD",
]);
exports.publicOnlineBookingEmbedTelemetryRequestSchema = zod_1.z.object({
    protocolVersion: zod_1.z.literal(exports.ONLINE_BOOKING_EMBED_PROTOCOL_VERSION),
    channelId: zod_1.z.string().uuid(),
    eventId: zod_1.z.string().uuid(),
    type: exports.publicOnlineBookingEmbedTelemetryEventTypeSchema,
    durationMs: zod_1.z.number().int().min(0).max(120_000),
    occurredAt: zod_1.z.string().datetime({ offset: true }),
    errorCode: zod_1.z.string().trim().min(1).max(80).nullable().default(null),
});
exports.publicOnlineBookingEmbedTelemetryResponseSchema = zod_1.z.object({
    accepted: zod_1.z.literal(true),
});
exports.publicOnlineBookingAvailabilityQuerySchema = zod_1.z.object({
    configurationVersionId: zod_1.z.string().uuid().optional(),
    serviceId: zod_1.z.string().uuid(),
    date: bookingDateSchema,
});
exports.publicOnlineBookingCartAvailabilityRequestSchema = zod_1.z.object({
    configurationVersionId: zod_1.z.string().uuid().optional(),
    lineItems: exports.publicOnlineBookingLineItemsSchema,
    date: bookingDateSchema,
});
exports.publicOnlineBookingSlotSchema = zod_1.z.object({
    startAt: zod_1.z.string().datetime(),
    endAt: zod_1.z.string().datetime(),
});
exports.publicOnlineBookingAvailabilityResponseSchema = zod_1.z.object({
    date: bookingDateSchema,
    timezone: zod_1.z.string(),
    operationalLocationId: zod_1.z.string().uuid(),
    lineItems: zod_1.z.array(exports.publicOnlineBookingLineItemSnapshotSchema).min(1).max(10),
    totalDurationMinutes: zod_1.z
        .number()
        .int()
        .min(5)
        .max(exports.PUBLIC_ONLINE_BOOKING_MAX_COMBINED_DURATION_MINUTES),
    totalPriceCents: zod_1.z.number().int().nonnegative(),
    slots: zod_1.z.array(exports.publicOnlineBookingSlotSchema),
});
exports.onlineBookingAvailabilityDiagnosticSlotSchema = exports.publicOnlineBookingSlotSchema.extend({
    available: zod_1.z.boolean(),
    reasonCodes: zod_1.z.array(exports.onlineBookingAvailabilityReasonCodeSchema),
    eligibleTechnicianCount: zod_1.z.number().int().nonnegative(),
    availableTechnicianCount: zod_1.z.number().int().nonnegative(),
    capacity: zod_1.z.number().int().positive(),
});
exports.onlineBookingAvailabilityDiagnosticsQuerySchema = zod_1.z.object({
    serviceId: zod_1.z.string().uuid(),
    date: bookingDateSchema,
});
exports.onlineBookingAvailabilityDiagnosticsResponseSchema = zod_1.z.object({
    date: bookingDateSchema,
    timezone: zod_1.z.string(),
    operationalLocationId: zod_1.z.string().uuid(),
    serviceId: zod_1.z.string().uuid(),
    generatedAt: zod_1.z.string().datetime(),
    slots: zod_1.z.array(exports.onlineBookingAvailabilityDiagnosticSlotSchema),
    reasonCounts: zod_1.z.partialRecord(exports.onlineBookingAvailabilityReasonCodeSchema, zod_1.z.number().int().nonnegative()),
});
exports.onlineBookingSlotUnavailableDetailSchema = zod_1.z.object({
    code: zod_1.z.literal("ONLINE_BOOKING_SLOT_UNAVAILABLE"),
    message: zod_1.z.string(),
    reasonCode: exports.onlineBookingAvailabilityReasonCodeSchema,
});
exports.ONLINE_BOOKING_OUT_OF_AREA_ERROR_CODE = "ONLINE_BOOKING_OUT_OF_AREA";
exports.onlineBookingOutOfAreaErrorSchema = zod_1.z.object({
    code: zod_1.z.literal(exports.ONLINE_BOOKING_OUT_OF_AREA_ERROR_CODE),
    message: zod_1.z.string().trim().min(1).max(500),
    reasonCode: zod_1.z.literal("SERVICE_LOCATION_UNSUPPORTED"),
    operationalLocationId: zod_1.z.string().uuid(),
    postalCode: exports.usZip5Schema,
});
exports.publicOnlineBookingServiceAreaEligibilityQuerySchema = zod_1.z.object({
    configurationVersionId: zod_1.z.string().uuid().optional(),
    postalCode: exports.usZip5Schema,
});
const publicOnlineBookingServiceAreaEligibilityBaseSchema = zod_1.z.object({
    operationalLocationId: zod_1.z.string().uuid(),
    postalCode: exports.usZip5Schema,
});
exports.publicOnlineBookingServiceAreaEligibilityResponseSchema = zod_1.z.discriminatedUnion("eligible", [
    publicOnlineBookingServiceAreaEligibilityBaseSchema.extend({
        eligible: zod_1.z.literal(true),
        reasonCode: zod_1.z.null(),
        message: zod_1.z.null(),
    }),
    publicOnlineBookingServiceAreaEligibilityBaseSchema.extend({
        eligible: zod_1.z.literal(false),
        reasonCode: zod_1.z.literal("SERVICE_LOCATION_UNSUPPORTED"),
        message: zod_1.z.string().trim().min(1).max(500),
    }),
]);
exports.mobileAvailabilityProfileResponseSchema = zod_1.z.object({
    timezone: zod_1.z.string(),
    operationalLocation: exports.onlineBookingOperationalLocationSchema.pick({
        id: true,
        name: true,
        timezone: true,
    }),
    workingHours: team_1.weeklyWorkingHoursSchema,
    services: zod_1.z.array(exports.onlineBookingServiceSchema),
    capableServiceIds: zod_1.z.array(zod_1.z.string().uuid()),
    serviceArea: exports.onlineBookingServiceAreaSummarySchema.optional(),
});
exports.publicOnlineBookingAddressSchema = zod_1.z.object({
    addressLine1: zod_1.z.string().trim().min(2).max(160),
    addressLine2: zod_1.z
        .string()
        .trim()
        .max(160)
        .optional()
        .transform((value) => value || undefined),
    city: zod_1.z.string().trim().min(2).max(100),
    state: zod_1.z
        .string()
        .trim()
        .regex(/^[A-Za-z]{2}$/)
        .transform((value) => value.toUpperCase()),
    postalCode: zod_1.z
        .string()
        .trim()
        .regex(/^\d{5}(?:-\d{4})?$/),
    country: zod_1.z.literal("US").default("US"),
});
exports.publicOnlineBookingSubmissionRequestSchema = zod_1.z
    .object({
    configurationVersionId: zod_1.z.string().uuid().optional(),
    idempotencyKey: zod_1.z.string().uuid(),
    serviceId: zod_1.z.string().uuid().optional(),
    lineItems: exports.publicOnlineBookingLineItemsSchema.optional(),
    startAt: zod_1.z.string().datetime(),
    firstName: zod_1.z.string().trim().min(1).max(80),
    lastName: zod_1.z.string().trim().min(1).max(80),
    email: zod_1.z.string().trim().email().max(320).optional(),
    phone: zod_1.z.string().trim().min(7).max(32).optional(),
    companyName: zod_1.z
        .string()
        .trim()
        .max(160)
        .optional()
        .transform((value) => value || undefined),
    serviceAddress: exports.publicOnlineBookingAddressSchema,
    notes: zod_1.z
        .string()
        .trim()
        .max(2_000)
        .optional()
        .transform((value) => value || undefined),
    consentAccepted: zod_1.z.boolean().default(false),
    attribution: lead_1.publicLeadAttributionSchema.default({
        channel: "DIRECT",
        landingPath: null,
        referrer: null,
        utmSource: null,
        utmMedium: null,
        utmCampaign: null,
        utmTerm: null,
        utmContent: null,
        gclid: null,
        gbraid: null,
        wbraid: null,
        firstTouch: null,
        lastTouch: null,
        adUserDataConsent: "UNSPECIFIED",
    }),
    website: zod_1.z.string().trim().max(200).optional().default(""),
})
    .superRefine((value, context) => {
    if (!value.serviceId && !value.lineItems) {
        context.addIssue({
            code: "custom",
            path: ["lineItems"],
            message: "Choose at least one service.",
        });
        return;
    }
    if (value.serviceId &&
        value.lineItems &&
        (value.lineItems.length !== 1 ||
            value.lineItems[0]?.serviceId !== value.serviceId ||
            value.lineItems[0]?.quantity !== 1 ||
            Boolean(value.lineItems[0]?.notes))) {
        context.addIssue({
            code: "custom",
            path: ["lineItems"],
            message: "Legacy serviceId must match the single cart line.",
        });
    }
})
    .refine((value) => Boolean(value.email || value.phone), {
    path: ["email"],
    message: "Email or phone is required.",
});
exports.publicOnlineBookingSubmissionResponseSchema = zod_1.z.object({
    accepted: zod_1.z.literal(true),
    configurationVersionId: zod_1.z.string().uuid().optional(),
    confirmationCode: zod_1.z.string().regex(/^CF-[A-Z0-9]{10}$/),
    serviceName: zod_1.z.string(),
    lineItems: zod_1.z.array(exports.publicOnlineBookingLineItemSnapshotSchema).min(1).max(10),
    totalDurationMinutes: zod_1.z.number().int().min(5).max(36_000),
    totalPriceCents: zod_1.z.number().int().nonnegative(),
    startAt: zod_1.z.string().datetime(),
    endAt: zod_1.z.string().datetime(),
    timezone: zod_1.z.string(),
    payment: zod_1.z.object({
        status: zod_1.z.enum(["NOT_REQUIRED", "CHECKOUT_AVAILABLE", "UNAVAILABLE"]),
        checkoutUrl: zod_1.z.string().url().nullable(),
        reason: zod_1.z.string().nullable(),
    }),
});
function normalizePublicOnlineBookingLineItems(request) {
    if (request.lineItems)
        return request.lineItems;
    if (!request.serviceId)
        return [];
    return [{ serviceId: request.serviceId, quantity: 1 }];
}
function isSafeEmbedOrigin(value) {
    try {
        const url = new URL(value);
        if (url.origin !== value)
            return false;
        if (url.username || url.password)
            return false;
        return url.protocol === "https:" || isLocalDevelopmentHttpUrl(url);
    }
    catch {
        return false;
    }
}
function isSafeEmbedRedirectUrl(value) {
    try {
        const url = new URL(value);
        if (url.username || url.password)
            return false;
        if (url.protocol !== "https:" && !isLocalDevelopmentHttpUrl(url)) {
            return false;
        }
        return !url.hash;
    }
    catch {
        return false;
    }
}
function isLocalDevelopmentHttpUrl(url) {
    return (url.protocol === "http:" &&
        (url.hostname === "localhost" || url.hostname === "127.0.0.1"));
}
//# sourceMappingURL=booking.js.map